import type { GetCourseDetail200SectionsItemLecturesItemContentType } from './getCourseDetail200SectionsItemLecturesItemContentType';
import type { GetCourseDetail200SectionsItemLecturesItemPlatformSupport } from './getCourseDetail200SectionsItemLecturesItemPlatformSupport';

export type GetCourseDetail200SectionsItemLecturesItem = {
  /** 강의 콘텐츠 유형 */
  contentType?: GetCourseDetail200SectionsItemLecturesItemContentType;
  /**
   * 강의 콘텐츠 제공 URL (비디오 외)
   * @nullable
   */
  contentUrl?: string | null;
  /**
   * 강의 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 강의 길이(초)
   * @nullable
   */
  duration?: number | null;
  /** 강의 ID */
  id: string;
  /**
   * 현재 사용자의 강의 수강 완료 여부
   * @nullable
   */
  isCompleted?: boolean | null;
  /**
   * 강의 언어 코드
   * @nullable
   */
  language?: string | null;
  /** 섹션 내 강의 순서 */
  order: number;
  /** 강의 콘텐츠 지원 플랫폼 */
  platformSupport?: GetCourseDetail200SectionsItemLecturesItemPlatformSupport;
  /** 강의 제목 */
  title: string;
  /**
   * 강의 비디오 URL (존재 시)
   * @nullable
   */
  videoUrl?: string | null;
};
